<template>
  <el-dialog
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :destroy-on-close="false"
    top="5vh"
    title=""
    width="600px"
  >
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane v-for="item in lists" :key="item.label" :label="item.label" :name="item.label" :lazy="true">
          <textarea v-model="item.value" readonly style="width: 100%; height: 100%; min-height: 400px" no="1" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" style="margin-right: 30px;" no="2" @click="ediImportClickHandler()">{{ $t('SeaExport.exportThisPageEdi') }}</el-button>
      <el-button type="default" style="margin-right: 30px;" no="3" @click="closeHandler()">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { parseTime } from '@/utils'

export default {
  name: 'EdiOfVesselDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      resultMsg: '',
      defaultFileType: '',
      ediCollection: null,
      ediTemplate: null,
      lists: [],
      activeTabName: ''
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {
  },
  methods: {
    init(ediCollection, ediTemplate) {
      this.ediCollection = ediCollection
      this.ediTemplate = ediTemplate
      const list = []
      for (const key in ediCollection) {
        if (key === 'ediTextManifestInfoUUIDs') {
          continue
        }
        if (key === 'defaultFileType') {
          this.defaultFileType = ediCollection['defaultFileType']
        } else if (key !== 'encode') {
          const data = {
            label: key,
            value: ediCollection[key]
          }
          list.push(data)
        }
      }
      if (list.length > 0) {
        this.activeTabName = list[0].label
      }
      this.lists = list
    },
    ediImportClickHandler() {
      const { activeTabName } = this
      if (!activeTabName) return
      this.$confirm(this.$t('SeaExport.ExportEDI'), this.$t('SeaExport.Confirm'), {
        confirmButtonText: this.$t('constant.yes'),
        cancelButtonText: this.$t('constant.no'),
        type: 'info'
      }).then(() => {
        this.download(this.ediCollection[activeTabName])
      }).catch(() => false)
    },
    closeHandler() {
      this.$emit('close')
    },
    download(exportData) {
      const fileName = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + this.getExportFileFix()
      const exportBlob = new Blob([exportData])
      const downloadUrl = document.createElement('a')
      downloadUrl.href = window.URL.createObjectURL(exportBlob)
      downloadUrl.download = fileName
      const event = document.createEvent('MouseEvents')
      event.initMouseEvent('click', true, false, window, 0, 0,
        0, 0, 0, false, false, false, false,
        0, null)
      downloadUrl.dispatchEvent(event)
      downloadUrl.remove()
    },
    getExportCharSet() {
      const { ediCollection } = this
      if (ediCollection == null || !ediCollection.hasOwnProperty('encode') || (ediCollection.encode == null || ediCollection.encode === '')) {
        return 'utf-8'
      }
      return ediCollection.encode
    },
    getExportFileFix() {
      const { ediTemplate, defaultFileType } = this
      if (ediTemplate == null || (ediTemplate.defaultFileType == null || ediTemplate.defaultFileType === '')) {
        if (defaultFileType != null && defaultFileType !== '') {
          return defaultFileType
        }
        return '.data'
      }
      return ediTemplate.defaultFileType
    }
  }
}
</script>

<style scoped>

</style>
